module.exports = __webpack_public_path__ + "img/top3.39361c49.jpg";